<template>

  <modal id="detalhes-ocorrencia" class="modal-detalhes-ocorrencia" :titulo="titulo" :loading="loading">

    <template v-if="ocorrencia">
      <div id="aba-dados-principais" v-if="ocorrencia">

        <card>
          <div class="row gutters-xs ocorrencia">

            <v-input type="v-select" :options="listas.tiposServico" label="Tipo de Ocorrência"
                     class="col-6" @change="setTipoServico()" v-model="tipoServico" />

            <v-input type="date" class="col-6" label="Data da Ocorrência"
                     v-model="ocorrencia.dataOcorrencia" :error="validation.dataOcorrencia" />

            <v-input class="col-12" :error="validation.descricao"
                     v-model="ocorrencia.descricao" type="text" label="Descrição" />

          </div>
        </card>

      </div>
    </template>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <v-button :run="salvar" class="btn-outline-primary">Salvar</v-button>
    </template>

  </modal>

</template>

<script>

  import TipoServicoBusiness from "@/business/crud/TipoServicoBusiness.js";
  import FrontBusiness from "@/business/FrontBusiness.js";
  import Utils from "@/commons/Utils.js";
  import Modal from "@/components/Modal.vue";
  import OcorrenciaBusiness from "@/business/ocorrencia/OcorrenciaBusiness";
  import Card from "@/components/Layout/components/Card.vue";

  export default {

    name: "DetalhesOcorrencia",
    components: {
      Modal, Card
    },

    props: {
      anterior: Object,
      envolvido: Object,
      matricula: Object,
      registroAuxiliar: Object,
      indicador: Object,
      id: String,
      protocolo: [String, Object],
      targetBlank: Boolean,
      reloadPage: {type : Boolean, default: () => true},
    },

    modal:{
      width: 800,
      escapable: false
    },

    async mounted(){
      this.loading = true;
      await TipoServicoBusiness.getByDominioSimples('OCORRENCIA').then(l => this.listas.tiposServico = l);

      this.ocorrencia = {
        envolvidos: [],
        indices: {},
        tipoServico: {},
        matriculas: [],
        protocolos: [],
        registrosAuxiliares: [],
        indicadores: []
      };

      if(this.id){
        this.ocorrencia = await OcorrenciaBusiness.getById(this.id);
        this.tipoServico = this.ocorrencia.tipoServico;
        this.$set(this.ocorrencia, 'indicadores', this.ocorrencia.indicadores || []);
      }

      if(this.matricula){
        this.ocorrencia.matriculas.push(this.matricula);
      }

      if(this.registroAuxiliar){
        this.ocorrencia.registrosAuxiliares.push(this.registroAuxiliar);
      }

      if(this.indicador){
        this.ocorrencia.indicadores.push(this.indicador);
      }

      if(this.envolvido){
        this.ocorrencia.envolvidos.push(this.envolvido);
      }

      // Filtrar tipos de serviço por atribuição conforme contexto
      if (this.matricula || this.registroAuxiliar) {
        this.listas.tiposServico = this.listas.tiposServico.filter(t => (t.opcoes?.atribuicoes || ['RI', 'RTD', 'RCPJ']).includes('RI'));
      } else if (this.indicador) {
        const livrosRTD = ['REGISTRO_TD', 'REGISTRO_INTEGRAL', 'REGISTRO_CONSERVACAO', 'REGISTRO_INSCRICAO'];
        const atribuicao = livrosRTD.includes(this.indicador.livro) ? 'RTD' : 'RCPJ';
        this.listas.tiposServico = this.listas.tiposServico.filter(t => (t.opcoes?.atribuicoes || ['RI', 'RTD', 'RCPJ']).includes(atribuicao));
      } else if (this.protocolo) {
        const dominio = (typeof this.protocolo === 'object' ? this.protocolo.dominio : '') || '';
        let atribuicao = null;
        if (dominio.includes('RTD')) atribuicao = 'RTD';
        else if (dominio.includes('RCPJ')) atribuicao = 'RCPJ';
        else if (dominio.includes('RI')) atribuicao = 'RI';
        if (atribuicao) {
          this.listas.tiposServico = this.listas.tiposServico.filter(t => (t.opcoes?.atribuicoes || ['RI', 'RTD', 'RCPJ']).includes(atribuicao));
        }
      }

      this.ocorrencia.tipoServico = this.ocorrencia.tipoServico || {};

      this.loading = false;

    },

    computed:{

      titulo(){
        return this.id ? 'Editar Ocorrência' : 'Cadastrar Ocorrência';
      },

    },

    data() {
      return {
        loading: false,
        ocorrencia : null,
        tipoServico : this.ocorrencia?.tipoServico?.id,
        validation: {},
        listas: {
          tiposServico : []
        }
      }
    },

    methods:{

      close : FrontBusiness.closeModal,

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '#formulario-ocorrencia');
      },

      setTipoServico(){
        if(this.tipoServico){
          this.ocorrencia.tipoServico = this.listas.tiposServico.find(e => e.id == this.tipoServico);
        }
      },

      async salvar() {
        if(!this.ocorrencia.tipoServico?.id){
          return null;
        }

        let dto = Utils.clone(this.ocorrencia);
        //dto.envolvidos = dto.envolvidos?.filter(e => e).map(e => e.id);
        dto.matriculas = dto.matriculas?.filter(e => e).map(e => e.id);
        dto.registrosAuxiliares = dto.registrosAuxiliares?.filter(e => e).map(e => e.id);
        dto.protocolos = dto.protocolos?.filter(e => e).map(e => e.id);
        dto.indicadores = dto.indicadores?.filter(e => e).map(e => e.id);
        if (this.protocolo) dto.protocolos.push(typeof this.protocolo === 'object' ? this.protocolo.id : this.protocolo);
        dto.tipoServico = Utils.getObjectId(dto.tipoServico);
        let retorno = await OcorrenciaBusiness.save(dto, this.ocorrencia?.id).catch(this.showError);
        if(retorno){
          if (this.reloadPage) FrontBusiness.redirect(`ocorrencia/${retorno}/geral`, this.targetBlank);
          this.close(retorno);
        }
      },

    }

  }
</script>
